export interface StorageAccount {
  Name: string;
  ResourceGroup: string;
  Subscription: string;
  ProductID: string;
  Purpose: string;
  tStorageKey: number;
  AzureRegion: string;
}

export enum MenuType {
  Edit = 'edit',
  Delete = 'delete',
}
export interface StorageAccountMenuItems {
  id: string;
  label: string;
  getLink?: (name: string) => string;
  validationFunc: MenuType;
}
